"use client";

import { useEffect } from "react";

export default function PwaRegistration() {
  useEffect(() => {
    if (!("serviceWorker" in navigator)) return;

    void navigator.serviceWorker.register("/service-worker.js", {
      updateViaCache: "none",
    }).catch(() => {
      // PWA support is optional. Do not affect normal app startup.
    });
  }, []);

  return null;
}
